import { render } from "./TabelDataAnakBerasa.vue?vue&type=template&id=365e3e42"
import script from "./TabelDataAnakBerasa.vue?vue&type=script&lang=js"
export * from "./TabelDataAnakBerasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__